/**
 * Bespoke overrides for Shopify.actions:
 * - updateCart: emit events from `document` so the ThemeEvents bridge can refresh cart UI.
 * - openCart: close the header drawer if it is open, then open `cart-drawer-component`
 *   (fall back to the cart page when the drawer is absent).
 *
 * First `configure()` wins. This module is loaded immediately after the importmap and
 * before `content_for_header`, so it registers before apps.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      const mobileMenu = document.querySelector('header-drawer');
      if (mobileMenu instanceof HTMLElement) {
        const host = /** @type {{ isOpen?: boolean; close?: () => void }} */ (mobileMenu);
        if (host.isOpen === true && typeof host.close === 'function') {
          host.close();
        }
      }

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
